<template>
  <router-view />
</template>

<script>
export default {
  name: "facilityconfig",
};
</script>

